import { lazy } from 'react';

// This object will contain all features page modals components and corresponding configs.
// Each entry specified here must be used to set modal as `activeModal` in modal reducer.
// Common config can be imported from '../../components/modals/styled'.
export const featuresPageModals = {
  featurePreview: {
    component: lazy(() => import('./feature-preview')),
    config: {
      height: 'calc(100vh - 5px)',
      padding: '15px 0px',
      maxWidth: {
        lg: '750px',
        sm: '100%',
        md: '75%'
      }
    },
  }
};